export const SET_SERVICE_URI = 'SET_SERVICE_URI';